<script setup lang="ts">
import { computed, ref } from 'vue'
import plural from 'plural-ru'
import dayjs from '@/lib/dayjs'
import ProductReview from '~/ui-kit/products/ProductReview.vue'

interface RawReview {
  name: string
  profile_image: string
  link: string
  rating: number
  text: string
  response: string
  date: string
}

interface Context {
  reviews?: Record<string, RawReview[]>
  [key: string]: unknown
}

const props = defineProps<{
  context: Context
}>()

const reviewType = ref(0)
const reviewTypes = [
  { value: 0, slug: null, text: 'Все отзывы' },
  { value: 1, slug: 'market', text: 'Ярмарка мастеров' },
  { value: 2, slug: 'webinars', text: 'Вебинары' },
  { value: 3, slug: 'tutors', text: 'Консультация' }
]

const reviews = computed(() => {
  const reviewsCtx = props.context.reviews ?? {}

  const slug = reviewTypes[reviewType.value]?.slug
  const reviewItems = slug ? (reviewsCtx[slug] ?? []) : Object.values(reviewsCtx).flat()

  return reviewItems.map(review => ({
    user: { name: review.name, image: review.profile_image, link: review.link },
    review: {
      rating: review.rating,
      text: review.text,
      responseText: review.response,
      date: dayjs(review.date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    }
  }))
})

const avgRating = computed(() => {
  if (!reviews.value.length) return 0
  const sum = reviews.value.reduce((acc, val) => acc + val.review.rating, 0)
  return sum / reviews.value.length
})

const formatPlural = (value: number, one: string, two: string, five: string) =>
  `${value} ${plural(value, one, two, five)}`
</script>

<template>
  <div class="teacher-bio__tab teacher-bio__tab_reviews">
    <div class="flex-adaptive mb-4">
      <div class="teacher-bio__review-tabs">
        <v-button
          v-for="type in reviewTypes"
          :key="type.value"
          :mode="reviewType === type.value ? 'primary flat small' : 'primary text small'"
          class="mr-1"
          @click="() => (reviewType = type.value)"
        >
          {{ type.text }}
        </v-button>
      </div>

      <div class="ma-1 flex-spacer"></div>

      <div class="d-flex align-center">
        {{ formatPlural(reviews.length, 'отзыв', 'отзыва', 'отзывов') }}
        <v-rating class="ml-1" :value="avgRating"></v-rating>
      </div>
    </div>

    <ProductReview v-for="(r, i) in reviews" :key="i" response-caption="Ответ учителя" v-bind="r" class="mb-3" />
  </div>
</template>
